/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueryDto } from '../../models/query-dto';

export interface AiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json$Params {
  sessionId: string;
  interactionId: string;
}

export function aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json(http: HttpClient, rootUrl: string, params: AiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
  const rb = new RequestBuilder(rootUrl, aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json.PATH, 'post');
  if (params) {
    rb.path('sessionId', params.sessionId, {});
    rb.path('interactionId', params.interactionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QueryDto>;
    })
  );
}

aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Json.PATH = '/ai/sessions/{sessionId}/interactions/{interactionId}/accept';
